import { Link } from "react-router-dom";
import { ArrowLeft, Phone, Mail, Globe, Clock, Hourglass } from "lucide-react";
import { useApi, PageHeader, Panel, Loading } from "../components/kit";

function Pending({ children }) {
  return <span className="inline-flex items-center gap-1 rounded bg-amber-100 px-2 py-0.5 text-sm font-semibold text-amber-900"><Hourglass className="h-3.5 w-3.5" /> {children || "Awaiting setup"}</span>;
}

export default function HelpPage() {
  const { data: s, loading } = useApi("/settings");
  if (loading) return <Loading />;
  const j = s?.jalapeno || {};
  const verified = j.verified;
  const rows = [[Phone, "Phone", j.phone, j.phone && `tel:${j.phone}`], [Mail, "Email", j.email, j.email && `mailto:${j.email}`],
    [Globe, "Website", j.website, j.website?.startsWith("https://") && j.website], [Clock, "Hours", j.hours]];
  return (
    <div className="space-y-6 max-w-3xl">
      <Link to="/concern" className="inline-flex items-center gap-1 text-sm font-semibold text-muted-foreground"><ArrowLeft className="h-4 w-4" /> Report a Concern</Link>
      <PageHeader eyebrow="Harassment & interpersonal concerns" title="Help and Reporting" testid="help-header" />
      <div className="space-y-4 text-[17px]" data-testid="help-intro">
        <p>If you see or experience a violation of our Code of Conduct, harassment, violence, or a problem with how someone is treating you, you can bring it to your manager. That's always an option, never a requirement.</p>
        <p>If you'd rather speak to someone confidentially, we work with <b>Jalapeno Employee Engagement</b>, who offer confidential counsel. When you contact Jalapeno, your concerns <b>won't be shared with anyone at DCBC without your express consent</b>.</p>
        <p>You're in control. Nothing is passed on to management or ownership unless you decide it should be. If you do, you choose what's shared and how: whether you're named, or whether it's raised without identifying you. Jalapeno will talk you through your options.</p>
      </div>
      <Panel title={j.name || "Jalapeno Employee Engagement"} testid="jalapeno-panel">
        {!verified && <p className="mb-4"><Pending>Contacts awaiting verification by the Superadmin</Pending></p>}
        <dl className="grid gap-4 sm:grid-cols-2">
          {rows.map(([Icon, label, val, href]) => (
            <div key={label} className="flex items-start gap-3">
              <Icon className="h-5 w-5 mt-0.5 text-[color:var(--dcbc-red)]" aria-hidden="true" />
              <div><dt className="text-xs uppercase tracking-wider text-muted-foreground">{label}</dt>
                <dd className="font-medium" data-testid={`jalapeno-${label.toLowerCase()}`}>{verified && val ? (href ? <a href={href} className="underline">{val}</a> : val) : <Pending />}</dd></div>
            </div>
          ))}
        </dl>
        {verified && j.instructions && <p className="mt-5 whitespace-pre-line border-t pt-4">{j.instructions}</p>}
      </Panel>
      <Panel title="Approved reporting instructions" testid="help-instructions">
        {s?.help_instructions || s?.reporting_instructions ? <p className="whitespace-pre-line">{s.help_instructions || s.reporting_instructions}</p> : <Pending>Approved instructions awaiting setup</Pending>}
      </Panel>
    </div>
  );
}
